import React, { createContext, useContext, useState } from "react";

const EditModeContext = createContext();

export const EditModeProvider = ({ children }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingPageId, setEditingPageId] = useState(null);
  const [editingSection, setEditingSection] = useState(null);

  return (
    <EditModeContext.Provider
      value={{
        isEditMode,
        setIsEditMode,
        editingPageId,
        setEditingPageId,
        editingSection,
        setEditingSection,
      }}
    >
      {children}
    </EditModeContext.Provider>
  );
};

export const useEditMode = () => {
  const context = useContext(EditModeContext);
  if (!context) {
    throw new Error("useEditMode must be used within EditModeProvider");
  }
  return context;
};
